import { RolesUiQuery } from '../../../types/api.graphql'

export enum Role {
  SuperAdmin = 'super-admin',
  BpSuperAdmin = 'bp:super',
  BpSales = 'bp:sales',
  BuilderOwner = 'builder:owner',
  BuilderManager = 'builder:manager',
  BuilderProjectManager = 'builder:project-manager',
  BuilderAccounts = 'builder:accounts',
  BuilderViewOnly = 'builder:view-only',
  Worker = 'worker',
  Custom = 'builder:custom',
}

// Used for navigation - these will then fall back onto permissions
export const BASIC_ADMIN_ROLES = [
  Role.BuilderManager,
  Role.BuilderOwner,
  Role.SuperAdmin,
  Role.BuilderProjectManager,
  Role.BpSuperAdmin,
  Role.BuilderAccounts,
  Role.BuilderViewOnly,
  Role.BpSales,
]

const mapBPRoleToName = (roleName: string): string => {
  switch (roleName) {
    case 'super-admin':
      return 'Super admin'
    case 'bp:sales':
      return 'Sales'
    case 'builder:owner':
      return 'Owner'
    case 'builder:manager':
      return 'Manager'
    case 'builder:project-manager':
      return 'Project manager'
    case 'builder:accounts':
      return 'Accounts'
    case 'builder:view-only':
      return 'View only'
    case 'worker':
      return 'Worker'
    default:
      return roleName
  }
}

export const formatRoleName = (role: string) => {
  return mapBPRoleToName(role)
}

export const hasRestrictedRole = (roles) =>
  roles.some((role) => role.name === 'super-admin')

const AVAILABLE_ROLES_BY_USERS_ROLE: Record<string, string[]> = {
  ['builder:owner']: [
    'builder:owner',
    'builder:manager',
    'builder:project-manager',
  ],
  ['builder:manager']: ['builder:manager', 'builder:project-manager'],
  ['builder:project-manager']: [],
}

const isCurrentRoleCustom = (currentUserRoles: string[]) => {
  return (
    !currentUserRoles.includes('builder:owner') &&
    !currentUserRoles.includes('builder:manager') &&
    !currentUserRoles.includes('builder:project-manager') &&
    !currentUserRoles.includes('super-admin')
  )
}

export const getAvailableRolesForCurrentUser = (
  buildPassRoles: RolesUiQuery | undefined,
  currentUserRoles: string[]
) => {
  if (!buildPassRoles) {
    return []
  }

  // If the user is a super admin, they can assign any role
  if (currentUserRoles.includes('super-admin')) {
    return buildPassRoles?.roles || []
  }

  // Otherwise, we need to filter the roles based on all of the user's roles
  return (
    buildPassRoles.roles?.filter((role) => {
      for (const userRole of currentUserRoles) {
        if (AVAILABLE_ROLES_BY_USERS_ROLE[userRole]?.includes(role.name))
          return true

        // Check if the role is a custom role based on builderId
        const isCustomRole = !!role.builderId
        if (isCustomRole && !isCurrentRoleCustom(currentUserRoles)) return true
      }

      return false
    }) || []
  )
}
